import React from 'react';

import classnames from 'classnames';

import { useSize } from '../../../features/config';
import { AVATAR_SKELETON_LOADING, Skeleton, type SkeletonProps } from '../Skeleton';

import styles from '../Skeleton.module.scss';

import type { AvatarProps } from '../../Avatar/Avatar';

export type SkeletonAvatarProps = Omit<SkeletonProps, 'height' | 'width'> &
    Pick<AvatarProps, 'size'>;

export const SkeletonAvatar = ({
    className,
    size: sizeProp,
    style,
    ...rest
}: SkeletonAvatarProps) => {
    const size = useSize(sizeProp, 'medium', 'SkeletonAvatar');

    return (
        <Skeleton
            {...rest}
            className={classnames(styles.avatar, styles[size], className)}
            style={style}
            height={undefined}
            width={undefined}
            data-testid={AVATAR_SKELETON_LOADING}
        />
    );
};
